// CapcutBlurBGAny.jsx
import React, {useMemo} from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate} from "remotion";

export const Blur = ({
  background,          // ReactNode you want blurred (e.g. <MyScene .../>)
  children,            // Foreground copy (usually the same node, unblurred)
  zoom = 1.15,
  darken = 0.35,
  vignette = 0.35,
  // variable blur:
  blurMin = 12,
  blurMax = 38,
  pulseHz = 0.25,      // set 0 to keep blur constant
  blurStops,           // optional keyframes: [[frame, blurPx], ...]
}) => {
  const frame = useCurrentFrame();
  const {fps, width, height} = useVideoConfig();

  const blurPx = useMemo(() => {
    if (Array.isArray(blurStops) && blurStops.length >= 2) {
      return interpolate(
        frame,
        blurStops.map(([f]) => f),
        blurStops.map(([,v]) => v),
        {extrapolateLeft: "clamp", extrapolateRight: "clamp"}
      );
    }
    if (pulseHz > 0) {
      const t = frame / fps;
      const wave = 0.5 * (1 - Math.cos(2 * Math.PI * pulseHz * t)); // 0..1
      return blurMin + (blurMax - blurMin) * wave;
    }
    return blurMax;
  }, [frame, fps, blurStops, pulseHz, blurMin, blurMax]);

  return (
    <AbsoluteFill>
      {/* Blurred background copy */}
      <AbsoluteFill style={{overflow: "hidden", pointerEvents: "none"}}>
        <div
          style={{
            width: "100%", height: "100%",
            transform: `scale(${zoom})`,
            filter: `blur(${Math.round(blurPx)}px)`,
            willChange: "transform, filter",
          }}
        >
          {background}
        </div>
        {/* Tint + vignette */}
        <AbsoluteFill style={{background: `rgba(0,0,0,${darken})`}}/>
        {vignette > 0 && (
          <AbsoluteFill
            style={{
              boxShadow: `inset 0 0 ${Math.max(width, height) * 0.45}px rgba(0,0,0,${vignette})`,
            }}
          />
        )}
      </AbsoluteFill>

      {/* Foreground (sharp) */}
      <AbsoluteFill>{children}</AbsoluteFill>
    </AbsoluteFill>
  );
};

export default Blur;

;
    var _remotion_globalVariableA, _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
